import { useTheme } from '@mui/styles';
import Highcharts, { setOptions } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import { useEffect, useState } from 'react';

interface DonutChartProps {
	height?: string;
	width?: string | number;
	size?: number;
	innerRadius?: number;
	name?: any;
	title?: any;
	showLegend?: boolean;
	colors?: string[];
	data?: object[];
	isFromCustomReport?: any;
	customReportStyle?: any;
	isFiveSplice: any;
	xAndYAxisName?: any;
	noDataMessage?: string;
	enableDataLabels?: boolean;
}

const DonutChart: React.FC<DonutChartProps> = (props: any) => {
	const theme: any = useTheme();

	NoDataToDisplay(Highcharts);

	const [options, setOptions]: any = useState({});
	let [data, setData]: any = useState([]);
	console.log('data >> ', data);

	useEffect(() => {
		if (props?.data?.length > 0 && props?.isFiveSplice) {
			data = [];
			props?.data.map((val: any) => {
				if (val?.y !== 0) {
					data?.push(val);
				}
			});
			const tempData = data;
			data = tempData
				.slice()
				.sort((a: any, b: any) => b.y - a.y)
				.slice(0, 5);
			setData([...data]);
		} else {
			data = [];
			setData(...[]);
		}
		if (!props?.isFiveSplice) {
			props?.data.map((val: any) => {
				if (val.y !== 0) {
					data.push(val);
				}
			});
			const tempData = data;
			setData(tempData);
		}
		setDonutOptions();
	}, [props?.data]);

	let setDonutOptions = () => {
		const tempOptions = {
			chart: {
				plotBackgroundColor: theme.palette.background.light,
				backgroundColor: theme.palette.background.light,
				borderColor: theme.palette.background.light,
				height: props?.height,
				width: props?.width || 600,
				size: props?.size || null,
				className: 'highcharts-color-0',
				style: {
					fontFamily: 'Lato',
					textTransform: 'capitalize',
					fontSize: '14px !important',
					color: '#707070',
				},
				plotBorderWidth: null,
				plotShadow: false,
				type: 'pie',
			},
			title: {
				text: props?.title || '',
				style: {
					display: 'flex',
					flexDirection: 'column',
					color: theme.palette.text.primary,
				},
			},

			// tooltip: {
			//   formatter: (point: any) => {
			//     return '<b>' + point?.chart?.hoverPoint?.percentage?.toFixed(2) + '%</b>'
			//   },
			//   pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b> <br>of which woman users {point.custom}',
			// },

			accessibility: {
				point: {
					valueSuffix: '%',
				},
			},

			plotOptions: {
				pie: props?.isFromCustomReport
					? {
							// size: 150,
							allowPointSelect: false,
							innerSize: props?.innerRadius || 200,

							depth: 55,
							cursor: 'pointer',
							borderWidth: 0,
							dataLabels: {
								enabled: !!props?.enableDataLabels,
								// enabled: true,
								connectorShape: 'straight',
								formatter: (point: any) => {
									return (
										'<b>' +
										point?.chart?.hoverPoint?.percentage?.toFixed(2) +
										'%</b>'
									);
								},
								pointFormat: '{point.name}</b>',
								style: {
									fontSize: '14px',
									color: theme.palette.text.primary,
									// textOutline: 'none',
									// backgroundColor: theme.palette.background.alt,
								},
							},
							tooltip: {
								enabled: true,
								format:
									'<span style="font-size: 0.8em">{key}</span><br/>' +
									'{#each points}' +
									'<b>{data.xAndYAxisName.yAxisName}</b><br/>' +
									'<span style="color:{color}">\u25CF</span> ' +
									'<b>{y}</b><br/>' +
									'{/each}',
								valueDecimals: 2,
							},
							showInLegend: true,
					  }
					: {
							allowPointSelect: false,
							innerSize: props?.innerRadius || 200,
							depth: 55,
							cursor: 'pointer',
							dataLabels: {
								enabled: !!props?.enableDataLabels,
								// enabled: true,
								connectorShape: 'straight',
								format: '{point.percentage:.1f} %',
							},
							showInLegend: true,
					  },
			},
			credits: {
				enabled: false,
			},
			series: [
				{
					name: props?.name || '',
					colorByPoint: true,
					data: data?.length > 0 ? data : [],
				},
			],
			legend: {
				// enabled: !!props.showLegend,
				enabled: true,
				itemStyle: {
					fontFamily: 'Lato !important',
					color: theme.palette.text.primary,
					fontWeight: '400 !important',
					fontSize: window.innerWidth === 1920 ? '14px' : '12px',
				},
				itemHoverStyle: {
					color: '#707070',
				},
				itemHiddenStyle: {
					color: '#707070',
				},
			},
			colors: props.colors || [
				'#354e69',
				'#00E9FA',
				'#FF2366',
				'#6C63FF',
				'#02BC77',
				'#33cc33',
				'#ff9900',
				'#990000',
				'#cc66ff',
				'#993366',
				'#ffff99',
				'#0000cc',
			],
			lang: {
				noData: props?.noDataMessage || 'No data available',
			},
			noData: {
				style: {
					fontWeight: 'bold',
					fontSize: '14px',
					color: theme.palette.text.primary,
					backgroundColor: theme.palette.background.alt,
				},
				useHTML: true,
			},
			responsive: {
				rules: [
					{
						condition: {
							maxWidth: 500,
						},
						chartOptions: {
							// legend: {
							// 	layout: 'horizontal',
							// 	align: 'center',
							// 	verticalAlign: 'bottom',
							// 	itemMarginBottom: 10,
							// 	itemStyle: {
							// 		fontSize: '13px',
							// 		fontFamily: 'Lato !important',
							// 		color: '#707070',
							// 		fontWeight: '400 !important',
							// 	},
							// },
							legend: {
								layout: 'vertical',
								align: 'center',
								verticalAlign: 'bottom',
								itemMarginBottom: 10,
								itemStyle: {
									fontSize: window.innerWidth === 1920 ? '14px' : '12px',
									fontFamily: 'Lato !important',
									color: '#707070',
									fontWeight: '400 !important',
								},
							},
						},
					},
				],
			},
		};
		setOptions({ ...tempOptions });
		console.log(tempOptions, '>>>>>>tempOptions>>>>>');
	};
	return (
		<>
			<div
				style={
					props?.customReportStyle || {
						backgroundColor: '#fafcff',
						width: '100%',
						margin: 'auto auto',
					}
				}
			>
				<div style={{ backgroundColor: theme.palette.background.light }}>
					<HighchartsReact highcharts={Highcharts} options={options} />
				</div>
			</div>
		</>
	);
};

export default DonutChart;
